import {HTTP} from '@/services/HttpServices';
import {CancelToken} from 'axios';
import { BadgesCount } from '@/badge/BadgeModel';

const ROOT_URL = '/admin/sidebar-counts';

export function getBadgesCount(cancelToken?: CancelToken): Promise<BadgesCount> {
    return HTTP.get(ROOT_URL, cancelToken);
}